import React from "react";
import './worksheet-concepts-list.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import Path from "../../routes/routes-path";

class WorksheetConceptsList extends React.Component {

    constructor(props) {
        super(props)
        // console.log(this.props.params)
        let metaInfo = this.props.params
        this.state = {
            chapterTitle : metaInfo.title,
            chapterKey : metaInfo.chapterKey,
            conceptsList : metaInfo.concepts,
            chaterImage : metaInfo.chapterImageUrl
        }
        
    }

    componentDidMount() {
        this.checkForConceptWorksheet()
    }


    checkForConceptWorksheet() {
        let noWorksheet = true
        let concepts = this.state.conceptsList

        for (let i = 0; i < concepts.length; i++) {
            let concept = concepts[i]
            if (concept.webLink) {
                noWorksheet = false
                break;
            }
        }

        this.setState({ noWorksheet })
    }


    goToHomeScreen() {
        this.props.delegate && this.props.delegate.props.history.replace({ pathname: Path.HOME })
    }

    goToWorksheetsList() {
        this.props.back && this.props.back()
    }

    renderBreadcrumbForChapterList = () => {
        return (
            <div className='breadcrumb'>
                <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()} >{`Home >`}</span>
                <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToWorksheetsList()}>{`Worksheets >`}</span>
                <span className='title-1 pl-2'>{this.state.chapterTitle}</span>
                {/* <span className='pl-2'>{this.props.selectedItem.chapters ? this.getChapterNames(this.selectedItem?.chapterName) : this.props.selectedItem.chapter} {`>`}</span>
                    <span className='active pl-2'>{this.getDate(this.selectedItem.createdDate)}</span> */}
            </div>
        )
    }


    render() {
        return (
            <div className="worksheet-concepts-list">
                {/* <div className="text-right">
                    <img className="image-size" src={getImageSource(ImageConstants.HEADER_BG_IMAGE)}></img>
                </div> */}
                <div className="header-title-margin-top">
                    {this.renderBreadcrumbForChapterList()}
                    <div className="d-flex align-items-center">
                        <div><img className="chapter-image mr-2" src={this.state.chaterImage} ></img></div>
                        <div className="title">{this.state.chapterTitle}</div>
                    </div>
                    <div className="divider-line">
                        {/* <img className="divider-image-width" src={getImageSource(ImageConstants.TITLE_DIVIDER)}></img> */}
                    </div>
                </div>
                <div className="mt-1">
                    {
                        !this.state.noWorksheet ?
                            <div className="d-flex flex-column">
                                {
                                    this.state.conceptsList.length &&
                                    this.state.conceptsList.map(item => (
                                        <div className="d-flex align-items-center justify-content-between concept-name">
                                            <div>{item.text}</div>
                                            {item.webLink ? <div><a className="cursor-pointer" href={item.webLink} download><img className="download-icon" src={getImageSource(ImageConstants.CASE_STUDY_DOWNLOAD_ICON)} /></a></div> : <div>--</div>}
                                        </div>
                                    ))
                                }
                            </div>
                            :
                            <div>
                                <div className="text-center"><img className="no-worksheet-image" src={getImageSource(ImageConstants.NO_WORKSHEET_IMAGE)} /></div>
                                <div className="text-center no-worksheet-text">No worksheets found. Please try Later.</div>
                            </div>
                    }


                </div>
            </div>
        )
    }


}

export default WorksheetConceptsList;